import { useCallback, useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useApi, errMsg } from "@/lib/api";
import { fmt } from "@/lib/dates";

export const ScheduleMailBar = ({ weekStart }) => {
  const api = useApi();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/schedule/email-status", { params: { week_start: weekStart } }).then((r) => setSt(r.data)), [api, weekStart]);

  useEffect(() => {
    load();
  }, [load]);

  const send = async () => {
    if (st?.last && !window.confirm("Dit rooster is al eens verstuurd. Opnieuw versturen?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/schedule/send", null, { params: { week_start: weekStart } });
      toast.success(`Rooster wordt gemaild naar ${data.recipients} ${data.recipients === 1 ? "medewerker" : "medewerkers"}`);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const toggle = async (auto) => {
    try {
      await api.patch("/schedule/email-settings", { auto });
      setSt((p) => ({ ...p, auto }));
      toast.success(auto ? "Roostermail gaat elke zondag 18:00 automatisch" : "Automatische roostermail staat uit");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (!st) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 mb-4" data-testid="schedule-mail-bar">
      <Mail className="h-5 w-5 text-[#0D5C46]" />
      <p className="text-sm text-slate-600 flex-1 min-w-[180px]" data-testid="schedule-mail-status">
        {st.last ? `Verstuurd op ${fmt(st.last.sent_at, "d MMM HH:mm")}${st.last.count ? ` naar ${st.last.count} ${st.last.count === 1 ? "persoon" : "personen"}` : ""}${st.last.sent_by === "auto" ? " (automatisch)" : ""}` : "Dit rooster is nog niet gemaild."}
      </p>
      <label className="flex items-center gap-2 text-sm text-slate-700">
        <Switch checked={st.auto} onCheckedChange={toggle} data-testid="schedule-mail-auto-switch" /> Elke zondag 18:00
      </label>
      <Button size="sm" className="rounded-full" onClick={send} disabled={busy} data-testid="schedule-mail-send-button">Rooster versturen</Button>
    </div>
  );
};
